import React, { useState } from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";

const SectionContainer = styled.section`
  background-image: url("./assets/images/background_stone.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: ${theme.spacing.xl};
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  margin-top: -4px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing.lg};
    min-height: auto;
    height: auto;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    min-height: auto;
    height: auto;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;

  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 100%;
    padding: 0 ${theme.spacing.lg};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 ${theme.spacing.md};
  }
`;

const PurpleBanner = styled.div`
  background-image: url("./assets/images/how2play_banner.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 600px;
  aspect-ratio: 3;
  margin-bottom: ${theme.spacing.md};

  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 80%;
    margin-bottom: ${theme.spacing.lg};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    max-width: 90%;
    margin-bottom: ${theme.spacing.md};
  }
`;

const MainDescription = styled.div`
  text-align: center;
  color: ${theme.colors.text.primary};
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: ${theme.spacing.xxxl};
  max-width: 800px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: 1.1rem;
    margin-bottom: ${theme.spacing.xxxl};
    padding: 0 ${theme.spacing.md};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
    margin-bottom: ${theme.spacing.xl};
    padding: 0 ${theme.spacing.sm};
  }
`;

const GameArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 900px;
  margin-bottom: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: ${theme.spacing.lg};
  }
`;

const LeftCharacter = styled.div`
  position: absolute;
  left: 57px;
  bottom: 68px;
  z-index: 2;

  img {
    width: 180px;
    height: auto;
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
    left: 72px;
    bottom: 66px;
    img {
      width: 160px;
    }
  }

  @media (max-width: 834px) {
    left: 9px;
    bottom: 66px;
    img {
      width: 150px;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    left: 59px;
    bottom: 50px;
    img {
      width: 140px;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    left: -40px;
    bottom: 25px;
    img {
      width: 100px;
    }
  }

  @media (max-width: 390px) {
    left: -41px;
    bottom: 22px;
    img {
      width: 80px;
    }
  }

  @media (max-width: 376px) {
    left: -41px;
    bottom: 21px;
    img {
      width: 80px;
    }
  }

  @media (max-width: 320px) {
    left: -40px;
    bottom: 17px;
    img {
      width: 60px;
    }
  }
`;

const RightCharacter = styled.div`
  position: absolute;
  right: 5px;
  bottom: 36px;
  z-index: 2;

  img {
    width: 230px;
    height: auto;
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
    right: 28px;
    bottom: 38px;
    img {
      width: 200px;
    }
  }

  @media (max-width: 834px) {
    right: -37px;
    bottom: 39px;
    img {
      width: 190px;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    right: 18px;
    bottom: 27px;
    img {
      width: 180px;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    right: -80px;
    bottom: 7px;
    img {
      width: 140px;
    }
  }

  @media (max-width: 390px) {
    right: -74px;
    bottom: 3px;
    img {
      width: 120px;
    }
  }

  @media (max-width: 376px) {
    right: -77px;
    bottom: 4px;
    img {
      width: 120px;
    }
  }

  @media (max-width: 320px) {
    right: -63px;
    bottom: 5px;
    img {
      width: 90px;
    }
  }
`;

const CentralPhone = styled.div`
  position: relative;
  width: 600px;
  height: auto;
  aspect-ratio: 375 / 580;
  background-image: url("./assets/images/sp_asset_new.png");
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  z-index: 1;
  order: 2;
  margin-bottom: ${theme.spacing.xxxl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 450px;
    height: auto;
    margin-bottom: 60px;
    aspect-ratio: 450 / 650;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 375px;
    height: auto;
    aspect-ratio: 375 / 620;
    margin-bottom: 15px;
  }

  @media (max-width: 390px) {
    width: 350px;
    margin-bottom: 20px;
  }

  @media (max-width: 376px) {
    width: 320px;
    margin-bottom: 20px;
  }

  @media (max-width: 320px) {
    width: 290px;
    height: auto;
    aspect-ratio: 375 / 640;
    margin-bottom: 12px;
  }
`;

const GameScreen = styled.img`
  position: absolute;
  top: 11%;
  left: 50%;
  transform: translateX(-50%);
  width: 45.5%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
  z-index: 10;
  border-radius: 2px;
  box-shadow: 0 4px 24px 0 rgba(60, 40, 80, 0.18),
    0 1.5px 8px 0 rgba(60, 40, 80, 0.1);
  display: block;

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 48.9%;
  }

  @media (max-width: 320px) {
    width: 50%;
  }
`;

const StepContainer = styled.div`
  position: absolute;
  top: 76%;
  left: 50%;
  transform: translateX(-50%);
  width: 77%;
  z-index: 11;

  @media (max-width: 320px) {
    top: 72%;
  }
`;

const StepButton = styled.div`
  background-image: url("./assets/images/step_button.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: ${theme.spacing.xs};

  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-bottom: -3px;
  }
`;

const StepDescription = styled.div`
  background: rgba(255, 255, 255, 0);
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  max-height: 35%;
  overflow-y: auto;

  p {
    font-size: 1.2rem;
    line-height: 1.5;
    color: ${theme.colors.text.primary};
    margin: 2px 0;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    p {
      font-size: 1.1rem;
      line-height: 1.5;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    p {
      font-size: 1rem;
      line-height: 1.5;
    }
  }

  @media (max-width: 380px) {
    p {
      font-size: 1rem;
      line-height: 1.3;
    }
  }
`;

const NavigationButton = styled.button<{ direction: "left" | "right" }>`
  position: absolute;
  top: 34%;
  transform: translateY(-50%);
  ${(props) => (props.direction === "left" ? "left: 75px;" : "right: 75px;")}
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 15;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    ${(props) => (props.direction === "left" ? "left: 50px;" : "right: 50px;")}
    width: 25px;
    height: 25px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    ${(props) => (props.direction === "left" ? "left: 30px;" : "right: 30px;")}
    width: 20px;
    height: 20px;
  }

  @media (max-width: 320px) {
    ${(props) => (props.direction === "left" ? "left: 20px;" : "right: 20px;")}
    width: 20px;
    height: 20px;
  }
`;

const ProgressContainer = styled.div`
  position: absolute;
  top: 72%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 8px;
  align-items: center;
  z-index: 12;

  @media (max-width: ${theme.breakpoints.tablet}) {
    top: 72%;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    top: 73%;
  }

  @media (max-width: 320px) {
    top: 71%;
  }
`;

const ProgressIndicator = styled.div<{ isActive: boolean }>`
  width: 97px;
  height: 6px;
  border-radius: 3px;
  background: ${(props) => (props.isActive ? "#C4A4CC" : "#cccccc")};
  transition: background 0.3s ease;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 47px;
    height: 5px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 35px;
    height: 4px;
  }
`;

const GameStartButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: transform 0.3s ease;
  position: absolute;
  bottom: 90px;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);

  &:hover {
    transform: translateX(-50%) scale(1.05);
  }

  img {
    width: 250px;
    height: auto;
    display: block;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    bottom: 65px;
    img {
      width: 200px;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    bottom: 25px;
    img {
      width: 180px;
    }
  }

  @media (max-width: 320px) {
    bottom: 18px;
  }
`;

const CharacterSection: React.FC = () => {
  const gameSteps = [
    {
      image: "./assets/images/0018.PNG",
      step: "STEP1",
      description: "最初に「防サギ訓練」のストーリーを選ぼう",
    },
    {
      image: "./assets/images/0022.PNG",
      step: "STEP2",
      description:
        "シェパードの「シェパ」さんの案内にしたがってストーリーを進めよう",
    },
    {
      image: "./assets/images/0019.PNG",
      step: "STEP3",
      description:
        "出てくるクイズに挑戦してポイントを貯めながら詐欺について学んでいこう",
    },
    {
      image: "./assets/images/0020.PNG",
      step: "STEP4",
      description:
        "最後にクイズの成績が発表されるよ。満点を目指して何度もチャレンジしよう",
    },
  ];

  const [currentStep, setCurrentStep] = useState(0);

  const handlePrevStep = () => {
    setCurrentStep((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const handleNextStep = () => {
    setCurrentStep((prev) => (prev < gameSteps.length - 1 ? prev + 1 : 0));
  };

  const handleGameStart = () => {
    // 新しいタブでゲームページを開く
    window.open(
      "https://go.trendmicro.com/jp/forHome/mktcp/bosagi/game/",
      "_blank"
    );
  };

  return (
    <SectionContainer id="how-to-play">
      <Container>
        <PurpleBanner />

        <MainDescription>
          マンションで平和に暮らしている動物たちが次々と詐欺にあってしまった！
          <br />
          どうすれば防げたのか、彼らと一緒にクイズ形式で振り返りながらトレーニング！
        </MainDescription>

        <GameArea>
          <LeftCharacter>
            <img
              src="./assets/images/how2play_man.png"
              alt="Left Character"
              loading="lazy"
            />
          </LeftCharacter>

          <CentralPhone>
            {currentStep > 0 && (
              <NavigationButton direction="left" onClick={handlePrevStep}>
                <img
                  src="./assets/images/toggle_left.png"
                  alt="前へ"
                  loading="lazy"
                />
              </NavigationButton>
            )}
            {currentStep < gameSteps.length - 1 && (
              <NavigationButton direction="right" onClick={handleNextStep}>
                <img
                  src="./assets/images/toggle_right.png"
                  alt="次へ"
                  loading="lazy"
                />
              </NavigationButton>
            )}

            <GameScreen
              src={gameSteps[currentStep].image}
              alt="ゲーム画面"
              loading="lazy"
            />
            <StepContainer>
              <StepButton>{gameSteps[currentStep].step}</StepButton>
              <StepDescription>
                <p>{gameSteps[currentStep].description}</p>
              </StepDescription>
            </StepContainer>

            <ProgressContainer>
              {gameSteps.map((_, index) => (
                <ProgressIndicator
                  key={index}
                  isActive={index === currentStep}
                />
              ))}
            </ProgressContainer>
          </CentralPhone>

          <RightCharacter>
            <img
              src="./assets/images/how2play_character.png"
              alt="Right Character"
              loading="lazy"
            />
          </RightCharacter>

          <GameStartButton onClick={handleGameStart}>
            <img
              src="./assets/images/gamestart.png"
              alt="今すぐプレイ"
              loading="lazy"
            />
          </GameStartButton>
        </GameArea>
      </Container>
    </SectionContainer>
  );
};

export default CharacterSection;
